/* 增减项明细 */
<template>
  <div class="additionAmount">
    <Modal v-model="model" :title="`增减项费用明细`" :width="800" @on-cancel="cancel">
      <div class="additionAmount-main">
        <p
          style="margin-bottom: 20px;font-size: 16px;margin-top: -30px;color:#ec6464;"
        >总计：{{totalPrice | currency('¥', '2')}}</p>
        <Table v-if="additionList" :columns="columns" :data="additionList" disabled-hover tooltip>
          <template slot-scope="{row}" slot="type">
            <p>增减项费用</p>
          </template>
          <template slot-scope="{row}" slot="amount">
            <span v-if="row.type === 2" style="color:#E56A69;">{{row.amount | currency('¥', '2')}}</span>
            <span v-if="row.type === 3" style="color:#E56A69;">{{row.amount | currency('-¥', '2')}}</span>
          </template>
          <template slot-scope="{row}" slot="content">{{row.content}}</template>
          <template slot-scope="{row}" slot="createTime">{{row.createTime | date}}</template>
        </Table>
      </div>
      <div slot="footer" class="additionAmount-footer">
        <Button style="width:150px" class="red-btn" type="primary" @click="ok">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: false,
      columns: [
        {
          title: "类型",
          slot: "type",
          align: "center",
          width: 150
        },
        {
          title: "金额",
          align: "center",
          slot: "amount",
          width: 150
        },
        {
          title: "内容",
          align: "center",
          slot: "content",
          width: 300
        },
        {
          title: "创建时间",
          align: "center",
          slot: "createTime"
        }
      ]
    };
  },
  props: {
    /* 增减项费用明细 */
    additionList: {
      type: [String, Array],
      default: ""
    },
    totalPrice: {
      type: [String, Number],
      default: ""
    }
  },
  methods: {
    open() {
      this.model = true;
    },
    ok() {
      this.cancel();
    },
    cancel() {
      this.model = false;
    }
  }
};
</script>      